import React, { useState, useEffect, useContext } from "react";
import SubsidiaryProductReadOnlyRow from "./SubsidiaryProductReadOnlyRow";
import SubsidiaryProductTableRow from "./SubsidiaryProductTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function SubsidiaryProductTable({ key, setSubsidiaryProduct, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isUserSubsidiaryLoading, setIsUserSubsidiaryLoading] = useState(false);
	const [userSubsidiaries, setUserSubsidiaries] = useState([]);
	const [isSubsidiaryProductLoading, setIsSubsidiaryProductLoading] = useState(false);
	const [subsidiaryProducts, setSubsidiaryProducts] = useState([]);
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		companyProductKey: 0,
		subsidiaryCompanyId: 0,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		fetchUserSubsidiaries();
		fetchSubsidiaryProducts();
	}, []);

	const handleClose = (event) => {
		setSubsidiaryProduct(false);
	};

	function fetchUserSubsidiaries() {
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}

		setIsUserSubsidiaryLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: true,
				companyId: initialValues.companyId,
				loginId: initialValues.loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetSubsidiariesForUser", "/Service/UserService/GetSubsidiariesForUser", requestOptions, retrieveUserSubsidiarySuccess, retrieveUserSubsidiaryFail);
		} catch (error) {
			setIsUserSubsidiaryLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveUserSubsidiaryFail(redirect) {
		setIsUserSubsidiaryLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.userGetSubsidiaryFailed"));
	}

	function retrieveUserSubsidiarySuccess(responseData) {
		let getSubsidiariesForUserResponse;
		if (responseData) {
			getSubsidiariesForUserResponse = responseData.getSubsidiariesForUserResponse;
			if (getSubsidiariesForUserResponse && getSubsidiariesForUserResponse.errorCode === "0") {
				setUserSubsidiaries(getSubsidiariesForUserResponse.subsidiaryList.slice())
			} else if (getSubsidiariesForUserResponse && getSubsidiariesForUserResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getSubsidiariesForUserResponse) {
				setError(t("error.error") + " " + getSubsidiariesForUserResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserSubsidiaryLoading(false);
	}

	function fetchSubsidiaryProducts() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsSubsidiaryProductLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, companyId: initialValues.companyId,
				loginId: initialValues.loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserSubsidiaryProduct", "/Service/PartnerSubsService/GetUserSubsidiaryProduct", requestOptions, retrieveSubsidiaryProductSuccess, retrieveSubsidiaryProductFail);
		} catch (error) {
			setIsSubsidiaryProductLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveSubsidiaryProductFail(redirect) {
		setIsSubsidiaryProductLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.getProdFailed"));
	}

	function retrieveSubsidiaryProductSuccess(responseData) {
		let fetchUserSubsProductsResponse;
		if (responseData) {
			fetchUserSubsProductsResponse = responseData.fetchUserSubsProductsResponse;
			if (fetchUserSubsProductsResponse && fetchUserSubsProductsResponse.errorCode === "0") {
				setSubsidiaryProducts(fetchUserSubsProductsResponse.products.slice())
			} else if (fetchUserSubsProductsResponse && fetchUserSubsProductsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserSubsProductsResponse) {
				setError(t("error.error") + " " + fetchUserSubsProductsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsSubsidiaryProductLoading(false);
	}

	const handleDeleteClick = (event, subsidiaryProductItem, completeCallback) => {
		event.preventDefault();
		deleteSubsidiaryProduct(subsidiaryProductItem, completeCallback);
	};
	const deleteSubsidiaryProduct = (subsidiaryProductItem, completeCallback) => {
		let action = 3;
		if (subsidiaryProductItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: formValues.loginId,
			companyProductKey: subsidiaryProductItem.companyProductKey,
			subsidiaryCompanyId: subsidiaryProductItem.subsidiaryCompanyId,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserSubsidiaryProduct", "/Service/PartnerSubsService/DeleteUserSubsidiaryProduct", requestOptions, deleteSubsidiaryProductSuccess, deleteSubsidiaryProductFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteSubsidiaryProductFail(redirect, completeCallback) {
		setError(t("error.userProdEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteSubsidiaryProductSuccess(responseData, completeCallback) {
		let deleteUserSubsProductResponse;
		if (responseData) {
			deleteUserSubsProductResponse = responseData.deleteUserSubsProductResponse;
			if (deleteUserSubsProductResponse) {
				if (deleteUserSubsProductResponse.errorCode === "0") {
					resetRowTable();
					refreshSubsidiaryProduct();
				} else {
					setError(t("error.error") + " " +
						deleteUserSubsProductResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};
	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (subsidiaryProducts.length > 0) {
				subsidiaryProducts.map((subsidiaryProductItem, index) => {
					if (subsidiaryProductItem.companyProductKey === setValues.companyProductKey && subsidiaryProductItem.subsidiaryCompanyId === setValues.subsidiaryCompanyId) {
						setError(t("error.prodDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveSubsidiaryProduct(action, setValues, completeCallback);
			}
		}
	};
	const saveSubsidiaryProduct = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			companyProductKey: setValues.companyProductKey,
			subsidiaryCompanyId: setValues.subsidiaryCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserSubsidiaryProduct", "/Service/PartnerSubsService/AddUpdateUserSubsidiaryProduct", requestOptions, saveSubsidiaryProductSuccess, saveSubsidiaryProductFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveSubsidiaryProductFail(redirect, completeCallback) {
		setError(t("error.subsidiaryGetProdFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveSubsidiaryProductSuccess(responseData, completeCallback) {
		let addUpdateUserSubsProductResponse;
		if (responseData) {
			addUpdateUserSubsProductResponse = responseData.addUpdateUserSubsProductResponse;
			if (addUpdateUserSubsProductResponse) {
				if (addUpdateUserSubsProductResponse.errorCode === "0") {
					resetRowTable();
					refreshSubsidiaryProduct();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserSubsProductResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshSubsidiaryProduct() {
		fetchSubsidiaryProducts();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isSubsidiaryProductLoading || isUserSubsidiaryLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("page.subsidiary")}</th>
										<th className="list-th">{t("page.prodName")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<SubsidiaryProductTableRow
											index={count}
											userSubsidiaries={userSubsidiaries}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((subsidiaryProducts.length % 2) > 0) ? true : false} />
									}
									{(subsidiaryProducts.length > 0) ? (
										subsidiaryProducts.map((subsidiaryProductItem, index) => (
											<SubsidiaryProductReadOnlyRow
												index={count}
												t={t}
												subsidiaryProductItem={subsidiaryProductItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												add={add}
												setError={setError}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<SubsidiaryProductTableRow
											index={count}
											userSubsidiaries={userSubsidiaries}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((subsidiaryProducts.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(subsidiaryProducts.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("page.subsidiary")}</th>
										<th className="list-th">{t("page.prodName")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-close"
									id="edit-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default SubsidiaryProductTable;